import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { localizeType } from '../../commonType';
import { RootState } from '../../redux/rootReducer';
import { CONFIRM, TourRequired } from '../../util/strings';
import DopInformation from '../common/DopInformation/DopInformation';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import './EligibilityQualification.scss';
interface EligibilityQualificationType {
  localize: localizeType;
  onSelectionChange: (n: boolean) => void;
  checkAllEligibilityOptions: boolean;
}
const EligibilityQualification: FC<EligibilityQualificationType> = (
  props: EligibilityQualificationType,
): ReactElement => {
  const { localize, onSelectionChange, checkAllEligibilityOptions } = props;
  const dopCodeDetails = useSelector((state: RootState) => state.offerDetails?.currentOffer?.dopCodeDetails);
  const tourIncludedValue = useSelector((state: RootState) => state.offerDetails?.currentOffer?.tourTp);
  let tourIncluded = tourIncludedValue === TourRequired;
  const tourCriteria = ['income', 'required', 'companion'];
  let qualificationCriteria = {
    income: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.income',
    required: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.required',
    companion: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.companion',
    gifts: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.gifts',
    notice: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.notice',
    additionalFee: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.additional-fee',
    view: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.no-view-guaranteed',
    email: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.email-confirmation',
    confirm: 'preview-sales-engine.static-content.copy.eligibility-page.qualifications-1.confirm',
  };
  const options = Object.keys(qualificationCriteria).map((e) => {
    const isTourDependentCriteria = tourCriteria.indexOf(e) >= 0;
    if (e === CONFIRM) {
      return {
        isChecked: checkAllEligibilityOptions,
        key: localize(qualificationCriteria[e]),
        incluDoP: true,
        isDisabled: false,
        disableClass: '',
      };
    } else {
      return {
        isChecked: isTourDependentCriteria
          ? tourIncluded === true
            ? checkAllEligibilityOptions
            : false
          : checkAllEligibilityOptions,
        key: localize(qualificationCriteria[e]),
        incluDoP: false,
        isDisabled: isTourDependentCriteria ? (tourIncluded === true ? false : true) : false,
        disableClass: isTourDependentCriteria ? (tourIncluded === true ? '' : 'class-disabled') : '',
      };
    }
  });
  const [navigationQualification, setNavigationQualification] = useState(options);
  const [allChecked, setAllChecked] = useState(checkAllEligibilityOptions);

  useEffect(() => {
    if (checkAllEligibilityOptions) {
      onSelectionChange(true);
    }
  }, [checkAllEligibilityOptions, onSelectionChange]);

  const handleInputChange = (index, e) => {
    if (index === 'checkAll') {
      navigationQualification
        .filter((option) => !option.isDisabled)
        .map((option) => (option.isChecked = e.target.checked));
      setAllChecked(e.target.checked);
    } else {
      navigationQualification[index].isChecked = !navigationQualification[index].isChecked;
    }
    const checkCount = navigationQualification.filter((e) => e.isChecked).length;
    setAllChecked(navigationQualification.filter((e) => !e.isDisabled).length === checkCount ? true : false);
    setNavigationQualification(navigationQualification);
    onSelectionChange(navigationQualification.filter((e) => !e.isDisabled).length === checkCount);
  };
  let checkboxTitle = localize('preview-sales-engine.static-content.copy.eligibility-page.select-all');

  checkboxTitle = checkboxTitle && checkboxTitle ? checkboxTitle : 'Select All Eligibility Criteria';
  return (
    <>
      <div className="qualificationWrapper">
        <p>{localize('preview-sales-engine.static-content.copy.eligibility-page.qualification-instructions')}</p>
        <div className="selectAllWrapper">
          <label htmlFor="selectAll">
            <input
              id="selectAll"
              type="checkbox"
              onChange={(e) => handleInputChange('checkAll', e)}
              checked={allChecked}
            />
            {checkboxTitle}
          </label>
        </div>
        {navigationQualification.map((option, index) => {
          return (
            <div className="EligibilityList" key={index}>
              <label htmlFor={`${index}_eligibility`} className={option.disableClass}>
                <input
                  id={`${index}_eligibility`}
                  type="checkbox"
                  onChange={(e) => handleInputChange(index, e)}
                  disabled={option.isDisabled}
                  checked={option.isChecked}
                />
                {option.incluDoP ? (
                  <>
                    <ParseHtml htmlInput={option.key} />
                    <DopInformation dopCodeDetails={dopCodeDetails}></DopInformation>
                  </>
                ) : (
                  <ParseHtml htmlInput={option.key} />
                )}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default React.memo(withLocalization(EligibilityQualification));
